import React from "react";
//import "./homestyles.css";
import { useNavigate } from "react-router-dom";
//import compLogo from './CA-Markets-Global-Logo-Colour-02.png'
//
export default function Home() {
    const navigate = useNavigate();
    //<div><img src={compLogo} alt="CA Markets Global. Logo" width="230" height="48"/></div>
    return (
        <section className="grid gap-8">
            
                <div>
                    <h1 className="mt-10 mb-10 text-4xl font-medium text-center"> 电子协议</h1>
                    <p className="text-1xl font-medium text-center">请按需点击进入查阅以下协议细则，并填写正确资料并在协议上以电子方式签署。</p>
                </div>
          
                <div className="flex">
            
                    <table className ="mx-auto table-auto">
                        
                        <thead  className="bg-blue-500 text-black">
                            <tr >
                                <th class="px-1 py-5">编号</th>
                                <th class="px-1 py-5">协议名称</th>
                                <th class="px-1 py-5"></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr >
                                <td class="px-1 py-5">1</td>
                                <td class="px-10 py-5">代理（IB）协议、反恶意刷单承诺书</td>
                                <td ><input class='button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-2 px-10 hover:border-transparent rounded' type='button' value='在线签署协议' onClick={() => navigate('/ibagreement')} /></td>
                              
                            </tr>
                            <tr >
                                <td class="px-1 py-5">2</td>
                                <td class="px-10 py-5">代理返佣政策 (标准账户)</td>
                                <td><input class='button bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white border border-blue-500 py-2 px-10 hover:border-transparent rounded' type='button' value='在线签署协议' onClick={() => navigate('/ibsupplemental')} /></td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            
        </section>

    );
}